import { cn } from './cn';

/**
 * <Badge color="..." size="...">texto</Badge>
 *
 * Colors:
 *   - neutral (default)
 *   - primary
 *   - success
 *   - warning
 *   - danger
 *   - cyan
 *   - purple
 *
 * Sizes: sm | md
 */
const COLORS = {
    neutral: 'bg-surface-2 text-muted border-line',
    primary: 'bg-primary/15 text-primary border-primary/30',
    success: 'bg-success/15 text-success border-success/30',
    warning: 'bg-warning/15 text-warning border-warning/30',
    danger:  'bg-danger/15  text-danger  border-danger/30',
    cyan:    'bg-cyan2/15   text-cyan2   border-cyan2/30',
    purple:  'bg-purple2/15 text-purple2 border-purple2/30'
};

const SIZES = {
    sm: 'text-[10px] px-1.5 py-0.5',
    md: 'text-xs px-2 py-0.5'
};

const Badge = ({ color = 'neutral', size = 'md', className, children, ...rest }) => (
    <span
        className={cn(
            'inline-flex items-center gap-1 font-medium uppercase tracking-wide',
            'rounded-md border',
            COLORS[color] || COLORS.neutral,
            SIZES[size] || SIZES.md,
            className
        )}
        {...rest}
    >
        {children}
    </span>
);

export default Badge;
